module.exports = __webpack_public_path__ + "img/album17_22.01b84bd7.jpg";